var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "icon__with-text bg-light-grey",
      attrs: { id: _vm.schema.settings.id }
    },
    [
      _c("div", [
        _c("div", { staticClass: "container" }, [
          _vm.schema.settings.title
            ? _c("h2", { staticClass: "h2" }, [
                _vm._v(_vm._s(_vm.schema.settings.title))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "icon__with-text-item-wrapper" },
            _vm._l(_vm.schema.blocks, function(block) {
              return _c("div", { staticClass: "single__block" }, [
                _c(
                  "div",
                  { staticClass: "single__block-item" },
                  [
                    _c(
                      "v-link",
                      {
                        staticClass: "single__block-icon",
                        attrs: { href: block.settings.icon_link_url }
                      },
                      [
                        block.settings.icon_image.src &&
                        typeof block.settings.icon_image !== "string"
                          ? _c("img", {
                              staticClass: "reveal",
                              attrs: {
                                height: "48",
                                width: "48",
                                src: block.settings.icon_image.src,
                                alt: block.settings.icon_title
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        block.settings.icon_image &&
                        typeof block.settings.icon_image == "string"
                          ? _c("img", {
                              staticClass: "reveal",
                              attrs: {
                                height: "48",
                                width: "48",
                                src: block.settings.icon_image,
                                alt: block.settings.icon_title
                              }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "single__block-content" }, [
                      block.settings.icon_title
                        ? _c("span", { staticClass: "h4" }, [
                            _vm._v(_vm._s(block.settings.icon_title))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      block.settings.icon_content
                        ? _c("div", {
                            staticClass: "single__block-icon-content",
                            domProps: {
                              innerHTML: _vm._s(block.settings.icon_content)
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-link",
                      {
                        staticClass: "single__block-link link",
                        attrs: { href: block.settings.icon_link_url }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(block.settings.icon_link_text) +
                            "\n                            "
                        ),
                        _c("icon", {
                          attrs: { name: "chevron-right", size: "10px" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }